import { Button, Caption, List, Placeholder, Section, Spinner } from '@telegram-apps/telegram-ui';
import type { ProductClientLinks, ProductStatus } from '../../types/product';
import { clientTryOnMessage } from './productModalUtils';

type ProductLinksPanelProps = {
  productName: string;
  productStatus: ProductStatus;
  links: ProductClientLinks['links'] | null;
  loading: boolean;
  error: Error | null;
  onRetry: () => void;
  onDone: () => void;
  onCopyClientLink: (url: string) => void;
  onCopyClientMessage: (url: string) => void;
};

export function ProductLinksPanel({
  productName,
  productStatus,
  links,
  loading,
  error,
  onRetry,
  onDone,
  onCopyClientLink,
  onCopyClientMessage,
}: ProductLinksPanelProps) {
  return (
    <List style={{ maxHeight: '75vh', overflowY: 'auto' }}>
      {productStatus !== 'active' ? (
        <Section header="Отправить клиенту">
          <Placeholder header="Товар не активен" description="Активируйте товар, чтобы отправить его клиенту" />
        </Section>
      ) : loading ? (
        <Placeholder header="Загрузка">
          <Spinner size="m" />
        </Placeholder>
      ) : error ? (
        <Placeholder
          header="Ошибка"
          description={error.message || 'Не удалось загрузить ссылку'}
          action={
            <Button mode="filled" size="s" onClick={onRetry}>
              Повторить
            </Button>
          }
        />
      ) : links ? (
        <Section header="Отправить клиенту примерку">
          <div style={{ padding: '0 20px 16px', display: 'grid', gap: 12 }}>
            <div
              style={{
                padding: 12,
                borderRadius: 8,
                border: '1px solid var(--tgui--separator_color)',
                background: 'var(--tgui--secondary_bg_color)',
              }}
            >
              <Caption style={{ opacity: 0.72, display: 'block', marginBottom: 6 }}>
                Готовое сообщение
              </Caption>
              <Caption style={{ whiteSpace: 'pre-wrap' }}>{clientTryOnMessage(productName, links.default)}</Caption>
            </div>
            <Button mode="filled" stretched onClick={() => onCopyClientMessage(links.default)}>
              Скопировать сообщение
            </Button>
            <Button mode="outline" stretched onClick={() => onCopyClientLink(links.default)}>
              Только ссылка
            </Button>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <Button mode="outline" size="s" onClick={() => onCopyClientLink(links.story)}>
                Для Stories
              </Button>
              <Button mode="outline" size="s" onClick={() => onCopyClientLink(links.post)}>
                Для поста
              </Button>
              <Button mode="outline" size="s" onClick={() => onCopyClientLink(links.bio)}>
                Для Bio
              </Button>
              <Button mode="outline" size="s" onClick={() => onCopyClientLink(links.dm)}>
                Для DM
              </Button>
            </div>
            <Caption style={{ wordBreak: 'break-all', opacity: 0.72 }}>{links.default}</Caption>
          </div>
        </Section>
      ) : null}
      <Section header=" ">
        <Button mode="filled" stretched onClick={onDone}>
          Готово
        </Button>
      </Section>
    </List>
  );
}
